export const subpagesConfig: { [subpage: string]: any } = {
  about_us: {},
  jobs: {},
  news: {},
  contacts: {
    seoIndexSubpage: false,
  },
  employees: {},
};
